import axios from 'axios';
import { API } from '../api';

// Mover/editar una cita del cuadrante respetando la JORNADA del profesional (Ann 2026-09-08:
// «he movido una precita y me ha dejado ponerla en un descanso de Zsofi»). El servidor ahora
// responde 409 FUERA_DE_JORNADA si la cita cae fuera de las franjas del profesional; aquí se
// pregunta con claridad y, solo si la persona confirma, se reintenta forzando. Cualquier otro
// error se propaga tal cual. Si se cancela, se lanza un error marcado (cancelado=true).
export async function putActividad(id, body, opciones = {}) {
  try {
    return await axios.put(`${API}/cuadrante/actividades/${id}`, body);
  } catch (error) {
    const d = error?.response?.status === 409 ? error?.response?.data?.detail : null;
    if (d && d.code === 'FUERA_DE_JORNADA') {
      const ok = window.confirm(`${d.message}\n\n¿Quieres ponerla ahí de todos modos (fuera de la jornada del profesional)?`);
      if (!ok) { const e = new Error('Movimiento cancelado: fuera de jornada'); e.cancelado = true; throw e; }
      return await axios.put(`${API}/cuadrante/actividades/${id}`, { ...body, forzar_fuera_jornada: true });
    }
    throw error;
  }
}
